import React, {useEffect, useState} from 'react';
import {motion} from 'framer-motion';

interface IProgressBar {
  durationSeconds: number;
}

const ProgressBar = ({durationSeconds}: IProgressBar) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(p => Math.min(p + 100 / durationSeconds / 10, 100));
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="h-3 w-full max-w-xs bg-slate-300 rounded-full">
      <motion.div
        className="h-3 bg-[#34bb78] rounded-full"
        initial={{width: 0}}
        animate={{width: `${progress}%`}}
        transition={{ease: 'easeOut', duration: 0.2}}
      />
    </div>
  );
};

export default React.memo(ProgressBar);
